import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSkipMembership } from '@/actions/ui';
import { wrappedFetch } from '@h/fetch';
import { useTranslation } from '@c/Translations';

const MemberAuthButtons = () => {
  const dispatch = useDispatch();

  const isMembershipAvailable = !!useSelector(state => state.ui?.uiConfig?.membershipFormConfig?.membership_available);
  const isMembershipSkipped = !!useSelector(state => state.ui?.skipMembership);
  const hasMembershipInstance = !!useSelector(state => state.reservation?.hasMembershipInstance);
  const token = useSelector(state => state.reservation?.token);
  const secret = useSelector(state => state.reservation?.secret);
  const { t } = useTranslation();

  const login = () => {
    if (token && secret){
      logout();
    }else{
      dispatch(setSkipMembership(false));
    }
  };

  const logout = () => {
    wrappedFetch(`/api/memberships/${token}`, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'reservation-secret': secret,
      },
    }).then(() => {
      window.location.reload();
    });
  };

  if (!isMembershipAvailable) {
    return null;
  }

  let linkText = null;
  let onClickHandler = null;
  
  if (hasMembershipInstance) {
    linkText = t('checkout__member_logout');
    onClickHandler = logout;
  } else if (isMembershipSkipped) {
    linkText = t('checkout__member_login');
    onClickHandler = login;
  } else {
    return null;
  } 
  
  return (
    <div style={{ marginTop: '16px' }}>
      <a
        href="#"
        style={{ textDecoration: 'none' }}
        onClick={(e) => {
          e.preventDefault();
          onClickHandler();
        }}
      >
        {linkText}
      </a>
    </div>
  );
};

export default MemberAuthButtons;
